export default __webpack_public_path__ + "static/media/BankCard.beb04c6d.svg";